/**
 * Created by vladislav on 9/6/2022
 */

const AndroidPlatform = function () {
    AndroidBase.call(this, connector.ANDROID);
};

AndroidPlatform.prototype = Object.create(AndroidBase.prototype);
AndroidPlatform.prototype.constructor = AndroidPlatform;

AndroidPlatform.prototype.canReview = function () {
    return true;
};

AndroidPlatform.prototype.isShareSupported = function () {
    return true;
};

AndroidPlatform.prototype.isShareCheckBoxAvailable = function () {
    return false;
};

AndroidPlatform.prototype._requestReview = function (callback) {
    this.callNative("ReviewPlugin.requestReview", (code) => {
        callback(code);
    });
};

AndroidPlatform.prototype.isLatestVersionCheckSupported = function () {
    return true;
};

AndroidPlatform.prototype.canSwitchGame = function () {
    return true;
};
